import { render, staticRenderFns } from "./PartsInfo.vue?vue&type=template&id=5086bb0f&"
import script from "./PartsInfo.vue?vue&type=script&lang=js&"
export * from "./PartsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports